module.exports = __webpack_public_path__ + "img/IEC13840.c45a84d9.png";